import React from "react";
import { IonApp, IonPage, IonToolbar, IonButtons, IonMenuToggle, IonButton, IonContent } from '@ionic/react';
import AddressDetailsComponent from "./AddressDetailsComponent";
import MapComponent from "./MapComponent";


const Header = () => {
    return (
        <>
            <IonApp>
                <IonPage className="ion-page core-wrapper" id="main-content">
                    <IonToolbar className='header-toolbar'>
                        <IonButtons slot="start" className='home-btn'>
                            <IonMenuToggle>
                                <IonButton>
                                    <img src='../img/menu-icon.png' />
                                </IonButton>
                            </IonMenuToggle>
                        </IonButtons>
                        <img className='header-logo' src='../img/logo.png' />
                    </IonToolbar>

                    <IonContent className="ion-padding page-title">
                        <div className="wrapper dashboard-page  option-1 option-1-1">
                            <h1>Make A New Delivery</h1>
                           
                            <div className='payment desktop'>
                               <img src='../img/home-step.svg' />
                            </div>
                            <div className='payment mobile'>
                               <img src='../img/home-step.svg' />
                            </div>
                            <AddressDetailsComponent/>
                        </div>
                    </IonContent>
                </IonPage>
            </IonApp>
        </>
    )
}

export default Header;